const e = (e2, i) => ({ shouldSerialize: e2, serialize: i });
export {
  e as makeCondition
};
//# sourceMappingURL=makeCondition.js.map
